import api from './api'

/**
 * Serviço de Skills (Competências)
 */
export default {
  // ========================================
  // Catálogo & Assessments (já existiam)
  // ========================================

  /**
   * Listar skills (catalogo)
   */
  list(params = {}) {
    return api.get('/api/skills', { params })
  },

  /**
   * Criar skill no catalogo
   */
  create(skillData) {
    return api.post('/api/skills', skillData)
  },

  /**
   * Listar avaliacoes do usuario logado
   */
  listMyAssessments(params = {}) {
    return api.get('/api/skill-assessments/me', { params })
  },

  /**
   * Criar ou atualizar autoavaliacao
   */
  createAssessment(assessmentData) {
    return api.post('/api/skill-assessments', assessmentData)
  },

  /**
   * Listar avaliacoes de um usuario (para manager)
   */
  listUserAssessments(userId, params = {}) {
    return api.get(`/api/skill-assessments/user/${userId}`, { params })
  },

  // ========================================
  // Manager Endpoints (8 novos)
  // ========================================

  /**
   * 1. GET /api/skills/manager/team/kpis
   * KPIs da aba "Minha equipe"
   */
  getTeamKpis() {
    return api.get('/api/skills/manager/team/kpis')
  },

  /**
   * 2. GET /api/skills/manager/competencias
   * Lista de competências da equipe com nível e status
   */
  getManagerCompetencias(params = {}) {
    return api.get('/api/skills/manager/competencias', { params })
  },

  /**
   * 3. GET /api/skills/manager/competencias/kpis
   * KPIs da aba "Competências"
   */
  getCompetenciasKpis() {
    return api.get('/api/skills/manager/competencias/kpis')
  },

  /**
   * 4. GET /api/skills/manager/validations/pending
   * Validações pendentes de aprovação do manager
   */
  getPendingValidations() {
    return api.get('/api/skills/manager/validations/pending')
  },

  /**
   * 5. GET /api/skills/manager/validations/confirmed
   * Validações já confirmadas (aprovadas/rejeitadas) do mês
   */
  getConfirmedValidations() {
    return api.get('/api/skills/manager/validations/confirmed')
  },

  /**
   * 6. GET /api/skills/manager/validations/kpis
   * KPIs da aba "Validações"
   */
  getValidationsKpis() {
    return api.get('/api/skills/manager/validations/kpis')
  },

  /**
   * 7. PUT /api/skills/manager/validations/{id}/approve
   * Aprovar uma validação pendente
   */
  approveValidation(id) {
    return api.put(`/api/skills/manager/validations/${id}/approve`)
  },

  /**
   * 8. PUT /api/skills/manager/validations/{id}/reject
   * Rejeitar uma validação pendente
   */
  rejectValidation(id) {
    return api.put(`/api/skills/manager/validations/${id}/reject`)
  },

  /**
   * 9. GET /api/skills/manager/team-members
   * Membros da equipe com scores de competências já calculados
   */
  getManagerTeamMembers() {
    return api.get('/api/skills/manager/team-members')
  },
}
